/* eslint-disable no-magic-numbers -- NDC to screen-space conversion */
import type { Api } from '@technology/web3d/dist/esnext/Api.js';
import type { PointerInput } from '@technology/web3d/dist/esnext/InputHandler.js';
import { Vector3 } from '@technology/web3d-plugin-threejs';

export function isCursorNearInsertionPointHandle(
  event: PointerInput,
  handlePosition: Vector3,
  camera: Api['camera'],
  canvas: HTMLCanvasElement,
  thresholdPixels: number
): boolean {
  if (!camera || !canvas) {
    return false;
  }

  const rect = canvas.getBoundingClientRect();
  const projected = handlePosition.clone();
  projected.project(camera);

  const screenX = rect.left + (projected.x * 0.5 + 0.5) * rect.width;
  const screenY = rect.top + (-projected.y * 0.5 + 0.5) * rect.height;

  const dx = screenX - event.x;
  const dy = screenY - event.y;

  return Math.sqrt(dx * dx + dy * dy) < thresholdPixels;
}
